var map = {
	"./1-correct.png": 6272,
	"./2-correct.png": 1952,
	"./3-correct.png": 3492,
	"./4-correct.png": 1007,
	"./5-correct.png": 8622,
	"./6-correct.png": 6689,
	"./7-correct.png": 2913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 718;